/**
 * Generated by '@kontent-ai/model-generator@6.5.0'
 */
export const webhooks = {} as const;
